import React, { FunctionComponent, useContext } from 'react';
import FormularElement from './formBuilder/formularElement';
import { ReactComponent as ErrorImage } from '../assets/img/error/undraw_cancel_re_ctke.svg';
import ElementParser from './formBuilder/elementParser';
import { GlobalErrorStateContext } from './globalErrorContext';
import { Button, Grid, Typography } from '@mui/material';
import { useLocation, useParams } from 'react-router-dom';
import { URIParameterContext } from './contexte/URIParameterContext';
import { handleReturn } from './genericErrorPage';
import { PageLayoutContainer } from '../components/pageLayout/pageLayoutContainer';

interface CustomErrorPageProps {
  staticPagesConfig?: FormularElement[];
}

const CustomErrorPage: FunctionComponent<CustomErrorPageProps> = ({
  staticPagesConfig,
}) => {
  const { error } = useContext(GlobalErrorStateContext);
  const { URIParameter } = useContext(URIParameterContext);
  const { project } = useParams();
  const location = useLocation();

  const errorPage: FormularElement | undefined = staticPagesConfig?.find(
    (page: FormularElement) => page.route === '/error'
  );

  const showFallbackErrorImage = errorPage?.showFallbackErrorImage ?? true;
  const statusCode = location.state?.statusCode?.toString();
  const errorCode = error?.status?.toString() || statusCode?.toString();

  const getErrorMessage = () => {
    const errorEntryValue = errorPage?.errorsMap
      ?.find((err) => err.key === errorCode)
      ?.value?.trim();

    return (
      errorEntryValue ||
      (typeof error?.text === 'string' && error?.text?.trim()) ||
      (!errorCode || errorCode === '404'
        ? errorPage?.errorsMap?.find(({ key }) => key == '404')?.value ??
          errorPage?.labelDefaultErrorMessage
        : errorPage?.labelDefaultErrorMessage)
    );
  };

  return (
    <PageLayoutContainer
      pageLayout={errorPage?.pageLayout}
      disableFormLayout={errorPage?.disableFormLayout}
      customFormSpacing={errorPage?.customFormSpacing}
      verticalContentAlignment={errorPage?.verticalContentAlignment}
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column',
          padding: '20px',
          boxSizing: 'border-box',
          width: '100%',
        }}
      >
        {showFallbackErrorImage && <ErrorImage />}
        {error?.header && <Typography variant="h3">{error.header}</Typography>}
        {errorPage?.elements && errorPage.elements.length > 0 && (
          <Grid
            container
            marginBottom={1}
            alignItems="center"
            justifyContent="center"
          >
            <ElementParser elements={errorPage.elements} />
          </Grid>
        )}
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
            textAlign: 'center',
            gap: 4,
          }}
        >
          <Typography variant="subtitle1">{getErrorMessage()}</Typography>
        </div>
        <Button
          onClick={() => handleReturn(project, URIParameter)}
          size="large"
          color="primary"
          variant="contained"
          sx={{ marginTop: 3 }}
        >
          {errorPage?.labelErrorRestartButton || 'Jetzt neu starten'}
        </Button>
      </div>
    </PageLayoutContainer>
  );
};

export default CustomErrorPage;
